// ✅ components/SyncControls.jsx
import React from "react";

const SyncControls = ({
  startDateTime,
  endDateTime,
  setStartDateTime,
  setEndDateTime,
  updateDatabase,
  deliveryFilter,
  setDeliveryFilter
}) => {
  const deliveryOptions = [
    "all",
    "confirmed",
    "in_transit",
    "out_for_delivery",
    "attempted_delivery",
    "delivered",
    "failure",
    "ready_for_pickup",
    "picked_up",
    "label_purchased",
    "label_printed",
    "delayed",
    "pending"
  ];

  return (
    <div className="mb-4">
      <div className="mb-2">
        <label>Start Date & Time</label>
        <input
          type="datetime-local"
          className="form-control"
          value={startDateTime}
          onChange={(e) => setStartDateTime(e.target.value)}
        />
      </div>

      <div className="mb-2">
        <label>End Date & Time</label>
        <input
          type="datetime-local"
          className="form-control"
          value={endDateTime}
          onChange={(e) => setEndDateTime(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label>Filter by Delivery Status</label>
        <select
          className="form-control"
          value={deliveryFilter}
          onChange={(e) => setDeliveryFilter(e.target.value)}
        >
          {deliveryOptions.map(status => (
            <option key={status} value={status}>{status}</option>
          ))}
        </select>
      </div>

      <button className="btn btn-primary btn-lg" onClick={updateDatabase}>
        Sync Data
      </button>
    </div>
  );
};

export default SyncControls;
